// components/DesktopActionBar.js
import React from "react";

/**
 * DesktopActionBar
 *
 * Desktop counterpart of <AppFooter>: takes the same `buttons` array and
 * renders it as the inline `.desktop-action-bar` strip at the top of the
 * page. desktop.css hides it below 1024px, and hides the AppFooter on
 * desktop whenever this bar is present — so render both and each
 * breakpoint shows one.
 */
function DesktopActionBar({ buttons }) {
  const safeButtons = Array.isArray(buttons) ? buttons.filter(Boolean) : [];
  if (safeButtons.length === 0) return null;

  return (
    <div className="desktop-action-bar">
      {safeButtons.map(({ label, icon, onClick, disabled, id, testId }, index) => (
        <button
          key={id ?? index}
          type="button"
          onClick={onClick}
          disabled={!!disabled}
          data-testid={testId ? `${testId}-desktop` : undefined}
        >
          {icon} {label}
        </button>
      ))}
    </div>
  );
}

export default DesktopActionBar;
